"use strict";function t(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var e=t(require("styled-components")).default.section`
    border-bottom: solid 1px ${({theme:t})=>t.colors.grey[300]};
    overflow: hidden;

    button {
        background: transparent;
        border: none;
        width: 100%;
        text-align: left;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: 23px 15px 14px 0;

        .type-intro {
            margin: 0;
            letter-spacing: -0.3px;
            line-height: 24px;
        }

        svg {
            transform: rotate(-90deg);
            transition: transform 1s cubic-bezier(0.16, 1, 0.3, 1);

            path {
                fill: ${({theme:t})=>t.colors.primary.default};
            }
        }
    }

    .wrapper {
        transition: all 0.4s ease-in-out;
    }

    .accordion-content {
        padding: 8px 0 14px;

        > * {
            &:first-child {
                margin-top: 0;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    &.active {
        button {
            svg {
                transform: rotate(-270deg);
            }
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
